<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ tituloModal }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- contenido -->
        <v-card class="mx-auto" :loading="loading">
          <v-card-text class="text--primary px-8">
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="objDatos.nombres"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="objDatos.apellidos"
                  label="Apellidos"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="objDatos.identificacion"
                  label="CC"
                  disabled
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="objDatos.telefono"
                  label="Telefono"
                  required
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="objDatos.ciudad"
                  label="Ciudad"
                  required
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="objDatos.direccion"
                  label="Dirección"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="objDatos.tipoidentificacion"
                  label="Tipo de Identificacion"
                  required
                ></v-text-field>
              </v-col> -->
            </v-row>
          </v-card-text>
        </v-card>
        <!-- fin contenido -->
        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark :loading="loading">
            Guardar
          </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { db } from "../../firebase";
export default {
  name: "ModAdd",
  data: () => ({
    objDatos: {},
    dialog: true,
    loading: true,
    state: [
      { name: "Activo", val: true },
      { name: "Inactivo", val: false },
    ],
  }),
  props: {
    showModal: { type: Boolean, default: false },
    showRgistroUs: { type: Boolean, default: false },
    idConductor: { type: String, default: "" },
    identificacion: { type: String },
  },
  computed: {
    tituloModal() {
      return "AGREGAR";
    },
  },
  created() {
    this.objDatos.identificacion = this.identificacion;
    this.getData();
  },
  methods: {
    async getData() {
      try {
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    async save() {
      try {
        this.loading = true;
        // Guardar
        this.objDatos.creado = new Date();
        this.objDatos.duracion_sesion = 15;
        this.objDatos.estado = true;
        this.objDatos.disponibilidad = "";
        this.objDatos.nombres = this.objDatos.nombres.toUpperCase().trim();
        this.objDatos.apellidos = this.objDatos.apellidos.toUpperCase().trim();
        this.objDatos.ciudad = "BOGOTA";
        this.objDatos.tipoidentificacion = "CC";
        const resul = await db.collection("clientes").add(this.objDatos);
        this.$swal({ icon: "success", title: "Operación Exitosa", text: "" });
        this.cerrarModal();
        this.$emit("update:showRgistroUs", !this.showRgistroUs);
        console.log(resul.id);
        this.$emit("update:idConductor", resul.id);
        this.$emit("update:idVehiculo", resul.id);
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
      this.objDatos = {};
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>
